module.exports = __webpack_public_path__ + "img/cat-ears.64ae026b.png";